var comparison_chart = function()
{
	var instance = {};

	//Set scope variable to init dbtable with options, columns etc
	instance.init = function(scope, componentKey, component)
	{
		//initalise component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};
		scope[componentKey].data = component.init_config;
	};
	instance.update = function(scope, componentKey, resultComponentVal)
	{
		var config_data = scope[componentKey].data;
		
		//extend the component config with the result data
		$.extend( true, config_data, resultComponentVal.config );
		resultComponentVal.config = config_data;

		//reset component properties
		scope[componentKey] = {};
		scope[componentKey].instance = {};

		var tootltipObj = {
			"enabled" : true,
			"useHTML":true,
			"borderColor": "#000",
			"backgroundColor": "#13161C",
			"style": {"color": "#fff","opacity":".8", "zIndex":"9999" },
			//"zIndex":9999,
			//"shadow": false,
			"borderWidth": 0,
			"animation": true,
			"borderRadius": "4",
			"formatter": function()
			{
				var y = this.point.y;
				var item_label = this.point.name;
				if(typeof resultComponentVal.config.tooltip_format != 'undefined')
				{
					var tooltip_string = typeof resultComponentVal.config.tooltip_format != 'undefined'?resultComponentVal.config.tooltip_format:'';
					var value = this.point.value;
					var count = this.point.count;
					var selected_sample_count = typeof this.point.selected_sample_count != 'undefined'?this.point.selected_sample_count:'';
					item_label = typeof this.series.name != 'undefined'?this.series.name:item_label;

					if(typeof this.point.target != 'undefined')
					{
						return "<span class='tooltip_container'>"+this.point.name+": "+y+"</span>";;
					}
					
					var result_string = tooltip_string.replace("{label}", item_label);
					var result_string = result_string.replace("{value}", value);
					var result_string = result_string.replace("{count}", count);
					var result_string = result_string.replace("{selected_sample_count}", selected_sample_count);
					return '<span class="tooltip_container"><span style="color:'+ this.series.color +'">\u25CF</span>'+result_string+"</span>";
				}
				else if(typeof this.point.percentage != 'undefined')
				{
					var percentage = this.point.value;
					item_label = typeof this.series.name != 'undefined'?this.series.name:item_label;
					return '<span class="tooltip_container"><span style="color:'+ this.series.color +'">\u25CF</span>'+item_label+" : "+percentage+"</span>";
				}
				else if(typeof this.point.previous != 'undefined')
				{
					var previous = typeof this.point.previous != 'undefined'?this.point.previous:'';
					if(previous !== null)
					{
						var txt = y > previous ? "has increased":( y < previous? "has decreased": "remains the same");
						var prev_label = this.point.previous_label;
						return "<span class='tooltip_container'>The score "+txt+" vs "+prev_label+"</span>";
					}
					else
					{
						return '<span class="tooltip_container"><span style="color:'+ this.series.color +'">\u25CF</span>'+item_label+" : "+this.point.value+"</span>";
					}
				}
				else if(typeof this.point.target != 'undefined')
				{
					return "<span class='tooltip_container'>"+this.point.name+": "+y+"</span>";;
				}

			},
		}
		var positioner = function (labelWidth, labelHeight, point) {
				var height = this.chart.chartHeight-point.plotY+labelHeight+22 > this.chart.chartHeight? (point.plotY+22) : (point.plotY-labelHeight-8);
				var width = (this.chart.chartWidth / 2) - (labelWidth / 2);
				return {
					x: width,
					y: height
				};
			};

		var dataLabelsObj = {
			"crop": false,
			"enabled":true,
			"overflow": "none",
			"color": "#000000",
			"useHTML": true,
			"formatter": function(){
				if(typeof this.point.previous != 'undefined')
				{
					var previous_data = typeof this.point.previous != 'undefined'?this.point.previous:null;
					var arrow_up_color = typeof this.point.arrow_up_color != 'undefined'?this.point.arrow_up_color : 'green';
					var arrow_down_color = typeof this.point.arrow_down_color != 'undefined'?this.point.arrow_down_color : 'red';
					var null_data_display = this.point.null_data_display;
					var css_class = (this.y < 0) ? "datalabel datalabel-negative" : "datalabel";
					if(previous_data !== null)
					{
						if(isNaN(null_data_display) || null_data_display == null) {
							return '<span class="datalabel">'+null_data_display+'</span>';
						}
						
						return this.y > this.point.previous?'<span class="'+css_class+'">'+this.y+' <i style="color:'+arrow_up_color+'" class="fa fa-caret-up fa-lg"></i></span>':(this.y<this.point.previous?'<span class="'+css_class+'">'+this.y+' <i style="color:'+arrow_down_color+'" class="fa fa-caret-down fa-lg" /></span>':'<span class="datalabel">'+this.y+'</span>');
					}
					else
					{
						
						if(typeof(this.point.column_data_labels) != 'undefined')
						{
							if(this.point.y == 0)
							{
								return null;
							}
							else
							{
								return this.point.column_data_labels;
							}	
						}

						return '<span class="'+css_class+'">'+null_data_display+'</span>';
					}

				}

				if(typeof(this.point.column_data_labels) != 'undefined')
				{
					if(this.point.y == 0)
					{
						return null;
					}
					else
					{
						return this.point.column_data_labels;
					}	
				}

				if(typeof this.point.display_format != 'undefined')
				{
					var display_format = typeof this.point.display_format != 'undefined'?this.point.display_format:null;
					var new_format = display_format.replace("{y}",Highcharts.numberFormat(this.y,1).toString());					
					return new_format;
				}else{
					return Highcharts.numberFormat(this.y,1);
				}
			}
		};

		if(typeof resultComponentVal.config != 'undefined' && 
			resultComponentVal.config != null &&
			typeof resultComponentVal.config.options != 'undefined' && 
			typeof resultComponentVal.config.options.tooltip != 'undefined' && 
			typeof resultComponentVal.config.options.tooltip.formatter != 'undefined')
		{
			resultComponentVal.config.options.tooltip = tootltipObj;
			if( typeof resultComponentVal.config.options.tooltip.positioner != 'undefined')
			{
				if(resultComponentVal.config.options.tooltip.positioner != false){
					resultComponentVal.config.options.tooltip.positioner = positioner;
				}
			}
		}


		if( typeof resultComponentVal.config != 'undefined' && 
			resultComponentVal.config != null &&
			typeof resultComponentVal.config.options != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions.column != 'undefined' && 
			typeof resultComponentVal.config.options.plotOptions.column.dataLabels != 'undefined' &&
			typeof resultComponentVal.config.options.plotOptions.column.dataLabels.enabled != 'undefined' &&
			resultComponentVal.config.options.plotOptions.column.dataLabels.enabled != false )
		{
			resultComponentVal.config.options.plotOptions.column.dataLabels = dataLabelsObj;
		}

		//update stackLabels formatter (used only for stacked column charts with stackLabels enabled = true)
		if( typeof resultComponentVal.config != 'undefined' && 
			resultComponentVal.config != null &&
			typeof resultComponentVal.config.options != 'undefined' && 
			typeof resultComponentVal.config.options.yAxis != 'undefined' &&
			typeof resultComponentVal.config.options.yAxis.stackLabels!= 'undefined' &&
			typeof resultComponentVal.config.options.yAxis.stackLabels.enabled!= 'undefined' &&
			resultComponentVal.config.options.yAxis.stackLabels.enabled != false )
		{
			var stackedLabelsObject = {
				"style": {
					"color": "black"
				},
				"useHTML":true,
				"enabled": true,
				"crop": false,
				"overflow": "allow",
				"formatter": function() {
					var series = this.axis.chart.series;
					var labelPoint = null;
					var compare_null_values = false;

					//Find the item in series array having the property show_value_as_label
					for (var i in series)
					{
						if (typeof series[i].options != 'undefined' && typeof series[i].options.show_value_as_label != 'undefined' && series[i].options.show_value_as_label == true)
						{
							labelPoint = series[i].options.data[this.x];
							compare_null_values = typeof series[i].options.compare_null_values != 'undefined'? series[i].options.compare_null_values: false;
							break;
						}
					}

					//If labelPoint not found
					if(labelPoint == null)
					{
						//Find the last series of the chart
						var series_length = series.length;
						series_length--;

						var labelPoint = ( typeof series[series_length] != 'undefined' &&
						typeof series[series_length].options.data != 'undefined' &&
						typeof series[series_length].options.data[this.x] != 'undefined' )? series[series_length].options.data[this.x]:{};
					}


					//If label point was found
					if(typeof labelPoint.y != 'undefined' && typeof labelPoint.previous != 'undefined')
					{
						var previous_data = typeof labelPoint.previous != 'undefined' ? labelPoint.previous : null;
						var arrow_up_color = typeof labelPoint.arrow_up_color != 'undefined'?labelPoint.arrow_up_color : 'green';
						var arrow_down_color = typeof labelPoint.arrow_down_color != 'undefined'?labelPoint.arrow_down_color : 'red';
						var null_data_display = labelPoint.null_data_display;
						var css_class = (labelPoint.y < 0) ? "datalabel datalabel-negative" : "datalabel";
						previous_data = compare_null_values == true && previous_data == null ? 0 :previous_data;
						if(previous_data !== null)
						{
							if(isNaN(null_data_display) || null_data_display == null) {
								return '<span class="datalabel">'+null_data_display+'</span>';
							}

							return labelPoint.y > labelPoint.previous?'<span class="'+css_class+'">'+labelPoint.y+' <i style="color:'+arrow_up_color+'" class="fa fa-caret-up fa-lg"></i></span>':(labelPoint.y<labelPoint.previous?'<span class="'+css_class+'">'+labelPoint.y+' <i style="color:'+arrow_down_color+'" class="fa fa-caret-down fa-lg" /></span>':'<span class="datalabel">'+labelPoint.y+'</span>');
						}
						else
						{
							return '<span class="'+css_class+'">'+null_data_display+'</span>';
						}
					}

					return typeof labelPoint.y != 'undefined'?Highcharts.numberFormat(labelPoint.y,1):'-';
				}
			};
			resultComponentVal.config.options.yAxis.stackLabels = stackedLabelsObject;
		}

		//update component
		scope[componentKey].data = resultComponentVal.config;

		setTimeout(function () 
		{
			//get the chart object
			var chart = angular.element(document.getElementById(componentKey)).highcharts();

			var chart_height = chart.chartHeight;
			var plotHeight = chart.plotHeight;
			var chart_options = chart.options;
			var yAxis = typeof chart_options.yAxis != 'undefined' ? chart_options.yAxis: {};
			var yAxis = typeof yAxis[0] != 'undefined'? yAxis[0] : yAxis;
			var min_val = typeof yAxis.min != 'undefined'? yAxis.min: null;
			var max_val = typeof yAxis.max != 'undefined'? yAxis.max: null;
			// var yAxisHeight = typeof yAxis.height != 'undefined'?yAxis.height:0;

			$.each(chart.series, function(index, series)
			{
				$.each(series.data, function(i, point) 
				{
					if(point.y < min_val) 
					{
						//If the point value is less that the minimum plot value of the chart, show the label at the bottom
						new_y = plotHeight - 25;

						if(typeof point.dataLabel != 'undefined')
						{
							var new_x_label_length = typeof point.dataLabel.width != 'undefined'?point.dataLabel.width:null;
							var new_x_pos = typeof point.plotX != 'undefined'?point.plotX:null;

							if(new_x_pos != null)
							{
								new_x_pos = new_x_pos - (new_x_label_length/2) -1;
								point.dataLabel.attr({y:new_y, x:new_x_pos});
							}
							else
							{
								point.dataLabel.attr({y:new_y});
							}
						}
					}
					else if(point.y > max_val) {
						//If the point value is greater that the maximum plot value of the chart, show the label at the top
						new_y = 0;
						point.dataLabel.attr({y:new_y});
					}
				});
			});
			
		}, 500);
	};

	return instance;
};
